import React from 'react';
import { Link } from 'react-router-dom';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';

import eyeIcon from "../../../../common/images/eyeIcon.png";
import editIcon from "../../../../common/images/editIcon.png";
import trashIcon from "../../../../common/images/trashIcon.png";

const getCameraColums = (handleDelete, handleViewDetail) =>  {
  return [
    {
      key: 'name',
      label: 'CAMERA & TYPE',
      render: (row) => {
        const name = row.name ?? '';
        const category = row.category ?? '';

        return (
          <>
            <span className="camera-name-cls">{name}</span>{' '}
            {category === 'in' && (
              <span className="camera-in-cls">IN Camera</span>
            )}
            {category === 'out' && (
              <span className="camera-out-cls">OUT Camera</span>
            )}
          </>
        );
      },
    },
    {
      key: 'entityName',
      label: 'ASSIGNED BUNK',
      render: (row) => {
        const entityName = row.entityName ?? '';
        const entityDistrict = row.entityDistrict ?? '';
        const entityState = row.entityState ?? '';

        return (
          <>
            <span className="agency-name-txt">{entityName}</span>
            <div className="agency-address1-txt">{entityDistrict}, {entityState}</div>
          </>
        );
      },
    },
    {
      key: 'bunkIncharges',
      label: 'BUNK INCHARGE',
      render: (row) => {
        const firstName = row.bunkIncharges[0]?.firstName ?? '';
        const lastName = row.bunkIncharges[0]?.lastName ?? '';
        const phone = row.bunkIncharges[0]?.phone ?? '';

        return (
          <>
            <span className="bunk-incharge-name">{firstName} {lastName}</span>
            <div className="bunk-incharge-phone">{phone}</div>
          </>
        );
      },
    },
    {
      key: 'isActive',
      label: 'STATUS',
      render: (row) => {
        return (row.isActive==true) ? <span className='status-active-cls'>ACTIVE</span> : <span className='status-inactive-cls'>INACTIVE</span>;
      },
    },
    {
      key: 'actions',
      label: 'ACTION',
      render: (row) => (
        <>
          <span
            onClick={() => handleViewDetail(row)}
            title="View Details"
            role="button"
            className="text-secondary me-2"
            style={{ cursor: 'pointer' }}
          >
            <img src={eyeIcon} className='action-icons eye-icon' alt='eyeIcon' />
          </span>
        </>
      ),
    },
  ];
}

export default getCameraColums;